<template>
    <div>
        <div v-bind:class="ContentBlockBaseProps.Class" v-bind:style="ContentBlockBaseProps.Style">
            <div :class="BlockProps.Shadow? 'shadow-sm mb-3' : ''" :style="{'background-color' : BlockProps.BGColor + ' !important'}">
                <div class="container position-relative" v-bind:style="ContainerPadding">
                    <div class="w-lg-75 mx-lg-auto" style="z-index:50">
                        <div class="text-center mb-5">
                            <omnieditor :iseditmode="iseditmode" editortype="tinymce" class="text-cap" keyDown v-model="BlockProps.Leadin" tag-name="span" :init="EditorConfig" />
                            <omnieditor :iseditmode="iseditmode" editortype="tinymce" class="display-4" keyDown v-model="BlockProps.Headline" tag-name="h1" :init="EditorConfig" />
                        </div>

                        <div style="border: 1px solid #efefef" class="row p-4 justify-content-center align-items-sm-center col-sm-divider text-center text-sm-start gx-5 mb-5 mb-sm-7 shadow-lg">
                            <div class="col-sm-auto  text-center">
                                <h5 class="mb-0">Notaries Online:</h5>

                                <div v-if="!Loaded" class="spinner-border text-light spinner-border-sm" role="status"></div>
                                <span v-else class="d-block fs-5 mt-2" style="font-size:30px !important;"><i :class="NumNotaries > 0? 'text-primary bi-check-circle' : 'text-red bi-x-circle'"></i> {{NumNotaries > 0? 'Yes' : 'No'}}</span>

                            </div>
                            <!-- End Col -->

                            <div class="col-sm-auto  text-center">
                                <h5 v-if="NumNotaries > 0" class="mb-0">Estimated Wait Time:</h5>
                                <h5 v-else="NumNotaries > 0" class="mb-0">Notaries Returning:</h5>

                                <div v-if="!Loaded" class="spinner-border text-light spinner-border-sm" role="status"></div>
                                <span v-else>
                                    <span v-if="NumNotaries > 0" class="d-block fs-5 mt-2" style="font-size:30px !important;"> {{WaitTime}}</span>
                                    <span v-else class="d-block fs-5 mt-2"> {{NextServiceTime}}</span>
                                </span>

                            </div>
                            <!-- End Col -->

                            <div class="row" data-no-divider>
                                <div class="col-md-12  text-center" style="font-size:12px; font-style:italic;color:grey;margin-top:20px">
                                    
                                    <span style="" v-if="NumNotaries <= 0">even when notaries are not immediately available, </span>
                                    <span>you can also schedule your notarization for a future appointment</span><span v-if="NumNotaries > 0"> or get an instant online notarization with a live Notary now.</span>
                                </div>
                            </div>
                        </div>
                        <!-- End Row -->

                    </div>

                    <div class="row">
                        <div class="col-md-12 text-center">
                            <omnieditor :iseditmode="iseditmode" editortype="tinymce" class="display-4" keyDown v-model="BlockProps.Footer" tag-name="div" :init="EditorConfig" />
                        </div>
                    </div>
                    <div class="w-lg-65 mx-lg-auto" v-if="BlockProps.ShowFlourish" style="overflow:hidden;z-index:40">
                        <!-- SVG Shape -->
                        <figure class="position-absolute top-50 end-0 translate-middle-y d-none d-md-block" style="width: 8rem;margin-right:-0rem;">
                            <img class="img-fluid" src="/unify/assets/svg/components/three-arrows-1.svg" alt="Image Description">
                        </figure>
                        <!-- End SVG Shape -->
                        <!-- SVG Shape -->
                        <figure class="position-absolute top-50 start-0 translate-middle-y d-none d-md-block" style="width: 10rem; margin-left: -8rem;">
                            <img class="img-fluid" src="/unify/assets/svg/components/three-arrows-2.svg" alt="Image Description">
                        </figure>
                        <!-- End SVG Shape -->
                    </div>
                </div>
            </div>
        </div>

        <div v-if="iseditmode" style="z-index:300" class="modal" :id="'editor' + BlockProps.UId" tabindex="-1" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
            <div class="modal-dialog modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">Options</h5>
                    </div>
                    <div class="modal-body">
                        <hr style="margin: 0px; margin-bottom:10px;" />
                        <propertybaseeditors :blockprops="BlockProps" :additionalcfg="AdditionalCfg"></propertybaseeditors>
                        <propertytogglededitor propertyname="ShowFlourish" :blockprops="BlockProps" prompt="Show Decorative Flourish"></propertytogglededitor>


                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-sm btn-secondary" data-bs-dismiss="modal">Done</button>
                        <!--<button type="button" class="btn btn-sm btn-primary">Save changes</button>-->
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    import EventHub from '/src/Util/EventHub.js';
    import ContentBlockBase from '/src/components/ContentCreator/ContentBlockBase.vue'
    import { computed, ref, nextTick } from 'vue'
    import { toast } from 'vue3-toastify';
    import axios from '/src/components/NovaAxios.js';

    export default {
        inheritAttrs: false,
        name: 'NotaryQ',
        mixins: [ContentBlockBase],
        props: ['notaryconfig'],
        components: {
        },
        computed:
        {           
            WaitTime: function () {
                if (this.WaitTimeMinutes < 1) {
                    return "< 1 minute";
                }

                var msg = `aprox. ${this.WaitTimeMinutes.toFixed(0)} minutes.)`;
                if (this.NumInLine == 1) {
                    msg += " You are next in line.";
                } else {
                    msg += `${this.NumInLine} people in line currently.`;
                }
            },
            NotaryConfig: function () {
                var x = this.Store.TenantConfig;
                if (this.notaryconfig) {
                    return this.notaryconfig
                }

                if (this.Store && this.Store.TenantConfig && this.Store.TenantConfig.serviceConfigNotary) {
                    return this.Store.TenantConfig.serviceConfigNotary;
                }
            }
        },
        data() {
            return {  
                NextServiceTime: '',
                WaitTimeMinutes: 0,
                NumInLine: 0,
                NumNotaries: 0,
                Loaded: false,
                AdditionalCfg: 'https://admin.notarylaunchpad.com/home/sitesettings#NotarySettings'
            };
        },
        methods:
        {
            FetchNotaryQ: function () {
                var that = this;
                var token = document.querySelectorAll('input[name=__RequestVerificationToken]')[0].value;
                axios.postForm('/API/GetNotaryQ', {},
                    {
                        cache:false,
                        headers: {
                            'RequestVerificationToken': token
                        }
                }).then(function (response) {
                    if (response.data.success) {
                        that.Loaded = true;
                        that.WaitTimeMinutes = response.data.waittime;
                        that.NumInLine = response.data.numinline;
                        that.NumNotaries = response.data.numproviders;
                        that.NextServiceTime = response.data.nextavailable;
                    }
                    else {
                        toast.error("Failed to load notary queue info. " + response.data.msg);
                    }
                }).catch(function (error) {
                    toast.error("Failed to load notary queue info. Please refresh the page and try again.");
                });
            },
            EditProperties: function () {
                var id = '#editor' + this.BlockProps.UId;
                var modalEl = document.querySelector(id);
                if (modalEl == null) {
                    return;
                }
                var modal = bootstrap.Modal.getOrCreateInstance(modalEl); // Returns a Bootstrap modal instance
                modal.show();
            }
          
        },

        setup(props, context)
        {             
            return {} // anything returned here will be available for the rest of the component
        },
        created()
        {           
        },
        beforeUnmount()
        {
        },
        mounted() {
            this.FetchNotaryQ();
            nextTick().then(() => {
      
            });
        }
    }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
    /* Style the .contact-content div */
    .contact-content {
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center;
        position: relative;
        z-index: 1;
    }

    .contact-content::before {
        content: "";
        display: block;
        position: absolute;
        z-index: -1;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        background: rgba(0,0,0,.7);
    }
    
        /* Style the content inside .contact-content */
        .contact-content .row {
            color: #fff; 
        }

        /* Style the content divs inside .contact-content */
        .contact-content .col-1 {
            /* Add your styling for the icon column */
        }

        .contact-content .col-11 {
            /* Add your styling for the address column */
        }
</style>

